import { fetchWithAuth } from "./fetchWithAuth";

export async function loadCustomerOptions(inputValue: string) {
  try {
    const response = await fetchWithAuth(
      `/customers?search=${encodeURIComponent(inputValue)}&sort=ascending`
    );
    const data = await response.json();

    return (data.customers ?? []).map((customer: any) => ({
      label: `${customer.identifier}`,
      value: customer.id
    }));
  } catch {
    // fetchWithAuth already surfaced the error; the select just shows no options.
    return [];
  }
};
